import { useTranslation } from "@/i18n/client";
import { Box, SxProps, Typography } from "@mui/material";
import dayjs from "dayjs";
import { DividerCustom } from "../Divider/DividerCustom";
import { useState } from "react";

import { useReadScreen } from "@/hooks/useReadScreen.hook";
import ModalContactSuccess from "@/modules/find-my-car/components/modal/ModalContactSuccess";
import color from "@/styles/color";
import IconLoader from "../IconLoader";
import ShareSocial from "../Social/ShareSocial";
interface HeaderTextProps {
  header?: string;
  publicDate?: string;
  viewer?: number | null;
  author?: string | null;
  link?: string;
}

const styleHeader: SxProps = {
  fontWeight: { xs: 600, sm: 600, xl: 600 },
  fontSize: { xs: "20px", sm: "24px", xl: "32px" },
  lineHeight: { xs: "30.22px", sm: "48px", xl: "48px" },
  color: "#333333",
};

const styleBoxHeader: SxProps = {
  display: "flex",
  justifyContent: "flex-start",
  margin: { xs: "16px 0px 8px 0px", md: "8px 0px", lg: "32px 0px 12px 0px" },
};

const styleBoxDetail: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  color: "#A1A1A1",
};

const styleBoxHeaderForMobile: SxProps = {
  color: "#A1A1A1",
};

const styleBoxDetailInSide: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  gap: { xs: "0px 24px", md: "0px 48px", lg: "0px 24px" },
};

const styleBoxDetailInSideForMobile: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  gap: { xs: "0px 0px", md: "0px 48px", lg: "0px 24px" },
};

const styleBoxDetailInSideFont: SxProps = {
  fontWeight: { xs: 400, sm: 400, lg: 400 },
  fontSize: { xs: "12px", sm: "14px", lg: "15px" },
  lineHeight: { xs: "24px", sm: "24px", lg: "24px" },
};

const styleBoxDetailSocial: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  gap: { xs: "0px", md: "0px 10px", lg: "0px 16px" },
  color: "white",
};

const styleBoxDetailSocialForMobile: SxProps = {
  color: "white",
  display: "flex",
  gap: { xs: "0px 16px", md: "0px 10px", lg: "0px 16px" },
  margin: { xs: "8px 0px 0px 0px", md: "0px 10px", lg: "0px 16px" },
};

const HeaderTextWithIcons = ({
  header,
  publicDate,
  viewer,
  author,
  link = "",
}: HeaderTextProps) => {
  const { isMoreThanSm } = useReadScreen();

  const { t } = useTranslation();
  const [copyLink, setCopyLink] = useState(false);

  const setShowAndClosePopup = async () => {
    setCopyLink(true);
    await new Promise(() => setTimeout(() => setCopyLink(false), 2500));
  };

  return (
    <Box>
      <ModalContactSuccess visible={copyLink} message={t("Article.dataLink.copyLink-success")} />
      <Box sx={{ ...styleBoxHeader }}>
        <Typography component={"h1"} sx={{ ...styleHeader }}>
          {header}
        </Typography>
      </Box>

      <Box sx={isMoreThanSm ? { ...styleBoxDetail } : { ...styleBoxHeaderForMobile }}>
        <Box sx={isMoreThanSm ? { ...styleBoxDetailInSide } : { ...styleBoxDetailInSideForMobile }}>
          <Box sx={isMoreThanSm ? undefined : { width: "100%" }}>
            <Typography sx={{ ...styleBoxDetailInSideFont }}>
              <IconLoader
                iconName="CalendarOutlineIcon"
                sx={{ fontSize: { xs: "18px", sm: "24px" }, color: color.gray190 }}
              />
              {t("Article.PublicDate")} {dayjs(publicDate).format("DD/MM/YYYY")}
            </Typography>
          </Box>
          {isMoreThanSm ? (
            <>
              <Box>
                <Typography sx={{ ...styleBoxDetailInSideFont }}>
                  <IconLoader
                    iconName="EyeViewOutlineIcon"
                    sx={{ fontSize: { xs: "18px", sm: "24px" }, color: color.gray190 }}
                  />
                  {t("Article.TotalVisitors")} {viewer}
                </Typography>
              </Box>
              {author != "" && (
                <Box>
                  <Typography sx={{ ...styleBoxDetailInSideFont }}>
                    <IconLoader
                      iconName="PencilIcon"
                      sx={{ fontSize: { xs: "18px", sm: "24px" }, color: color.gray190 }}
                    />
                    {t("Article.Author")} {author}
                  </Typography>
                </Box>
              )}
            </>
          ) : (
            <>
              {author != "" && (
                <Box sx={isMoreThanSm ? undefined : { width: "70%" }}>
                  <Typography sx={{ ...styleBoxDetailInSideFont }}>
                    <IconLoader
                      iconName="PencilIcon"
                      sx={{ fontSize: { xs: "18px", sm: "24px" }, color: color.gray190 }}
                    />
                    {t("Article.Author")} {author}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>

        <Box>
          {isMoreThanSm ? (
            []
          ) : (
            <Box>
              <Typography sx={{ ...styleBoxDetailInSideFont }}>
                <IconLoader
                  iconName="EyeViewOutlineIcon"
                  sx={{ fontSize: { xs: "18px", sm: "24px" }, color: color.gray190 }}
                />
                {t("Article.TotalVisitors")} {viewer}
              </Typography>
            </Box>
          )}
        </Box>

        <Box sx={isMoreThanSm ? { ...styleBoxDetailSocial } : { ...styleBoxDetailSocialForMobile }}>
          <ShareSocial link={link} showText={false} setStateCopyLink={setShowAndClosePopup} />
        </Box>
      </Box>
      <DividerCustom
        sx={{
          margin: {
            xs: "24px 0px !important",
            sm: "24px 0px !important",
            lg: "28px 0px !important",
          },
        }}
      ></DividerCustom>
    </Box>
  );
};

export default HeaderTextWithIcons;
